const notFound = "/not-found";
const style = "/style";
const help = "/help";
const admins = "/admins";
const directDeposit = "/direct-deposit";
const dashboard = "/";
const netEarnings = "/net-earnings";
const netEarningsAnomalyReport = "/net-earnings/reports/:id";
const roster = "/roster";
const userStatements = "/users/:id/statements";
const userTab = "/users/:id/:tab";
const users = "/users";
const grossEarnings = "/gross-earnings";
const otherReports = "/reporting/other";
const restricted = "/restricted";
const complianceReports = "/reporting/compliance";
const complianceReportsTab = "/reporting/compliance/:tab";
const paystubReport = "/reporting/compliance/paystub";
const cashBalanceReport = "/reporting/compliance/cash-balance";
const dduConsentReport = "/reporting/compliance/ddu-consent";
const usageReport = "/reporting/usage";
const enrollmentReport = "/reporting/enrollment";
const userSettings = "/user-settings";
const presettlementExclusions = "/reporting/presettlement-exclusions";
const balanceDistributorReport = "/reporting/balance-distributor";
const disbursementsReport = "/disbursements/report";
const disbursementsFileUpload = "/disbursements/file-upload";
const rewardsSetup = "/rewards/setup";
const rewardsReport = "/rewards/report";
const settings = "/settings";

const InternalRoutes = {
  users,
  userTab,
  userStatements,
  grossEarnings,
  roster,
  netEarnings,
  netEarningsAnomalyReport,
  directDeposit,
  otherReports,
  admins,
  help,
  style,
  notFound,
  restricted,
  enrollmentReport,
  usageReport,
  complianceReports,
  complianceReportsTab,
  paystubReport,
  cashBalanceReport,
  dduConsentReport,
  userSettings,
  dashboard,
  presettlementExclusions,
  balanceDistributorReport,
  disbursementsReport,
  disbursementsFileUpload,
  rewardsSetup,
  rewardsReport,
  settings,
};

export default InternalRoutes;
